// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1wbNm","delete":"styles_delete__1sFuu","update":"styles_update__6TM2V","add":"styles_add__3yqrL"};